import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'
import Modal from '../components/Modal/Modal'
import FormField from '../components/FormField/FormField'
import { Link } from 'react-router-dom'

import userIcon from '../assets/images/user-icon.svg'
import taxisIcon from '../assets/images/taxis-icon.png'
import eye from '../assets/images/eye.svg'
import eyeSlash from '../assets/images/eye-slash.svg'

import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import useAuth from '../hooks/useAuth'
import useMediaQuery from '../hooks/useMediaQuery'
import Announcement from '../components/Announcement/Announcement'

const Login = () => {
    const { isLoggedIn, login, taxisLogin } = useAuth()

    const [queryParams] = useSearchParams()
    const taxisToken = queryParams.get('t')

    const [inputs, setInputs] = useState({})
    const [errorMsgAdmin, setErrorMsgAdmin] = useState(false)
    const [errorMsgTaxis, seterrorMsgTaxis] = useState(
        queryParams.get('taxiserror')
    )
    const [passwordVisible, setPasswordVisible] = useState(false)
    const [taxisButtonEnabled, setTaxisButtonEnabled] = useState(false)

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible)
    }

    const isMobile = useMediaQuery('(max-width:1024px)')
    const navigate = useNavigate()

    useEffect(() => {
        document.title = 'Σύνδεση - Πλατφόρμα Ηλ. Πληρωμών Δήμου Δυτικής Λέσβου'

        if (isLoggedIn()) {
            navigate('/')
        }

        if (taxisToken) {
            taxisLogin(taxisToken)
            if (!isLoggedIn()) {
                seterrorMsgTaxis(true)
            }
        }
    }, [])

    const handleChange = event => {
        const name = event.target.name
        const value = event.target.value
        setInputs(values => ({ ...values, [name]: value }))
    }

    const loginWithCredentials = async e => {
        e.preventDefault()
        await login(inputs.email, inputs.password)

        if (!isLoggedIn()) {
            setErrorMsgAdmin(true)
        }
    }

    const divClasses = isMobile
        ? 'py-8 flex flex-col items-center'
        : 'py-16 px-28 text-center'

    const loginBody = (
        <div className="flex flex-col items-center md:m-20 m-10 md:w-auto w-full">
            <div className="bg-accent rounded-full w-fit p-6 md:my-10 md:self-center">
                <img width="30" height="30" src={userIcon} alt="user" />
            </div>

            <form
                className="flex flex-col w-full px-12 md:px-0"
                onSubmit={loginWithCredentials}
            >
                <FormField
                    type="email"
                    label="Email"
                    name="email"
                    labelOnSide={false}
                    onChange={handleChange}
                />
                <label className="text-base text-left text-primary mb-12">
                    <p className="text-base font-bold">Κωδικός</p>
                    <div className="flex border-b border-gray-300 items-end">
                        <input
                            type={passwordVisible ? 'text' : 'password'}
                            name="password"
                            className=" w-full mt-4"
                            onChange={handleChange}
                            min={0}
                            id="adminPassword"
                        />
                        <button
                            onClick={togglePasswordVisibility}
                            type="button"
                            className={'my-1'}
                        >
                            <img
                                src={passwordVisible ? eye : eyeSlash}
                                alt="show-pass"
                            />
                        </button>
                    </div>
                </label>

                {errorMsgAdmin ? (
                    <div className=" self-start text-left underline text-red-700 text-sm pb-7">
                        Το email ή ο κωδικός που εισάγατε είναι λανθασμένος
                    </div>
                ) : null}

                <div className="flex md:gap-8 justify-between md:py-12">
                    <button
                        type="submit"
                        className="m-auto bg-darkBlue text-white border border-darkBlue hover:bg-white hover:text-darkBlue rounded-lg py-3.5 px-10 transition-all"
                    >
                        Σύνδεση
                    </button>
                    <Link
                        to="/register"
                        className="m-auto bg-olive text-white border border-olive hover:bg-white hover:text-olive rounded-lg py-3.5 px-10 transition-all"
                    >
                        Εγγραφή
                    </Link>
                </div>
            </form>
        </div>
    )

    const TaxisLogin = () => (
        <>
            <main className="flex justify-center items-center">
                <div className="py-16 px-10 text-center flex flex-col items-center">
                    <Announcement
                        date="22/4/2024"
                        title="Aνακοίνωση - Απάντηση Αιτήματος Απριλίου"
                        content={
                            <>
                                <p className="text-gray-700 mb-4">
                                    Μπορείτε να απευθύνεστε στις αρμόδιες
                                    υπηρεσίες (
                                    <a
                                        href="https://www.mwlesvos.gr/tilefonikos-katalogos/"
                                        className="text-blue-500 hover:underline text-[#61703f] font-bold"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Σχετικά στοιχεία
                                    </a>
                                    ) προσκομίζοντας τα σχετικά δικαιολογητικά
                                    ταυτοποίησης κατά την επικοινωνία σας.
                                </p>
                            </>
                        }
                    />

                    <p className="font-light text-secondary text-l md:text-xl">
                        Αποκτήστε πρόσβαση σε προσωποποιημένες υπηρεσίες,
                        δημιουργήστε έναν λογαριασμό και παρακολουθήστε την
                        κατάσταση αιτημάτων καθώς και την θυρίδα σας. Για πλήρη
                        πρόσβαση στις e-Υπηρεσίες, συνδεθείτε μέσω TAXIS NET.
                    </p>

                    <div className="bg-accent rounded-full w-fit p-4 my-10">
                        <img width="30" height="30" src={userIcon} alt="user" />
                    </div>

                    <a
                        className={`flex items-center gap-2 text-accent font-semibold text-lg shadow-2xl rounded-xl px-4 py-2 transition-all duration-200 ease-in-out border border-white ${
                            taxisButtonEnabled
                                ? // TODO: Change again to hover and url when taxis wil be enabled
                                  'cursor-not-allowed'
                                : 'cursor-not-allowed'
                        } `}
                        href={taxisButtonEnabled ? '#' : null}
                    >
                        Σύνδεση με
                        <img src={taxisIcon} alt="TaxisNet" />
                    </a>

                    <div className="mt-12">
                        <label
                            htmlFor="toc"
                            className="font-normal flex flex-col md:flex-row items-center gap-2"
                        >
                            <input
                                type="checkbox"
                                name="toc"
                                className="w-5 h-5"
                                checked={taxisButtonEnabled}
                                onChange={() =>
                                    setTaxisButtonEnabled(!taxisButtonEnabled)
                                }
                            />

                            <p className="text-secondary">
                                Συμφωνώ με τους &nbsp;
                                <a
                                    href="/terms-and-conditions"
                                    className="text-darkBlue font-semibold"
                                >
                                    Όρους Χρήσης και την Πολιτική Απορρήτου.
                                </a>
                            </p>
                        </label>
                    </div>

                    {errorMsgTaxis ? (
                        <div className=" underline font-semibold text-red-700 text-base pt-10">
                            Η διαδικασία ταυτοποίησης μέσω taxis-net απέτυχε.
                        </div>
                    ) : null}
                </div>
            </main>
        </>
    )

    return (
        <>
            <main className="flex justify-center items-center m-3">
                <Modal classes=" w-full h-fit m-5 md:max-w-5xl md:m-12">
                    <Header includeLogo={true} withBorder={true} />

                    <div className={divClasses}>
                        <h1 className="font-bold  text-primary text-3xl ">
                            Είσοδος
                        </h1>
                        <div className="border-b-2 w-full">
                            <TaxisLogin />
                        </div>

                        {isMobile ? (
                            loginBody
                        ) : (
                            <Modal classes="max-w-10xl lg:m-24 min-w-max mx-8">
                                {loginBody}
                            </Modal>
                        )}
                    </div>
                </Modal>
            </main>

            <Footer />
        </>
    )
}

export default Login

// OLD LOGIN IS BELOW WAITING TO RETURN..

/**
 * import Header from '../components/Header/Header'
 * import Footer from '../components/Footer/Footer'
 * import Modal from '../components/Modal/Modal'
 *
 * import userIcon from '../assets/images/user-icon.svg'
 * import taxisIcon from '../assets/images/taxis-icon.png'
 *
 * import { useEffect, useState } from 'react'
 * import { useNavigate } from 'react-router-dom'
 *
 * import useAuth from '../hooks/useAuth'
 *
 * const Login = () => {
 *     const { isLoggedIn, login } = useAuth()
 *     const [errorMsg, setErrorMsg] = useState(false)
 *     const navigate = useNavigate()
 *
 *     useEffect(() => {
 *         if (isLoggedIn()) {
 *             navigate('/')
 *         }
 *     }, [])
 *
 *     useEffect(() => {
 *         document.title = 'Σύνδεση - Πλατφόρμα Ηλ. Πληρωμών Δήμου Αντιπάρου'
 *     }, [])
 *
 *     const handleLogin = async () => {
 *         await login()
 *         if (!isLoggedIn()) {
 *             setErrorMsg(true)
 *         }
 *     }
 *
 *     return (
 *         <>
 *             <main className="flex justify-center items-center">
 *                 <Modal classes="max-w-5xl mx-4 my-10">
 *                     <Header includeLogo={true} withBorder={true} />
 *                     <div className="py-16 px-10 text-center flex flex-col items-center">
 *                         <h1 className="font-bold text-primary text-3xl mb-8">
 *                             Είσοδος
 *                         </h1>
 *
 *                         <p className="font-light text-secondary text-l md:text-xl">
 *                             Αποκτήστε πρόσβαση σε προσωποποιημένες υπηρεσίες,
 *                             δημιουργήστε έναν λογαριασμό και παρακολουθήστε την
 *                             κατάσταση αιτημάτων καθώς και την θυρίδα σας. Για
 *                             πλήρη πρόσβαση στις e-Υπηρεσίες, συνδεθείτε μέσω
 *                             TAXIS NET.
 *                         </p>
 *
 *                         <div className="bg-accent rounded-full w-fit p-4 my-10">
 *                             <img
 *                                 width="30"
 *                                 height="30"
 *                                 src={userIcon}
 *                                 alt="user"
 *                             />
 *                         </div>
 *
 *                         <button
 *                             className="flex items-center gap-2 text-primary shadow-xl rounded-xl px-4 py-2"
 *                             onClick={() => handleLogin()}
 *                         >
 *                             Σύνδεση με
 *                             <img src={taxisIcon} alt="TaxisNet" />
 *                         </button>
 *                         {errorMsg ? (
 *                             <div className=" underline font-semibold text-red-700 text-base pt-10">
 *                                 Η διαδικασία ταυτοποίησης μέσω taxi-net
 *                                 απέτυχε...
 *                             </div>
 *                         ) : null}
 *                     </div>
 *                 </Modal>
 *             </main>
 *
 *             <Footer />
 *         </>
 *     )
 * }
 *     )
 * }
 */
